import { render } from "./TextButton.vue?vue&type=template&id=4aba4c82&ts=true"
import script from "./TextButton.vue?vue&type=script&lang=ts"
export * from "./TextButton.vue?vue&type=script&lang=ts"

import "./TextButton.vue?vue&type=style&index=0&id=4aba4c82&lang=scss"

import exportComponent from "/Users/colin/Documents/FUSE/code/live/fusestudio.net/Graphite/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__